import { ContractsState } from '../../models/account/contracts.state';
import {
  ActionsContracts,
  GET_CONTRACTS,
  GET_CONTRACTS_SUCCESS,
  SORT_CONTRACTS_COMPLETED,
  SORT_CONTRACTS_INIT,
  GET_CONTRACTS_ERROR
} from '../../actions/account/actions-contracts';

export const contractsInitState: ContractsState = {
  isLoading: true,
  sorting: 'ASC',
  contracts: [],
  loadingError: ''
};

/* eslint-disable */
export function reducersContracts(state = contractsInitState, action: ActionsContracts): ContractsState {
  switch (action.type) {
    case GET_CONTRACTS:
      return { ...state, isLoading: true, loadingError: '' };
    case GET_CONTRACTS_SUCCESS:
      return { ...state, sorting: 'ASC', contracts: action.payload, isLoading: false, loadingError: '' };
    case SORT_CONTRACTS_INIT:
      state = { ...state, isLoading: true, loadingError: '' };
      state.sorting = action.payload;
      return state;
    case SORT_CONTRACTS_COMPLETED:
      state = { ...state, isLoading: false, loadingError: '' };
      state.contracts = action.payload;
      return state;

    case GET_CONTRACTS_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    default:
      return state;
  }
}
